export default {
  DC_HEADER: [
    /\/driver-dc-private\/(.*\/)?delivery\/.*\/validate$/,
    /\/driver-dc-private\/(.*\/)?document\/.*$/,
    /\/servicepoint-dc-private\/.*$/
  ]
};
